import { useLocalStorage } from '@/composables/useLocalStorage';
import { defineStore } from 'pinia';
import { User } from './userStore';
const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const calcStorage = useLocalStorage<{
  steamUsername: string,
  saveLogin: boolean,
}>('calcForm');

export const useCalcFormStore = defineStore('calcForm', {
    state: () => ({
      balance: 0,
      promocode: '',
      discount: 0,
      steamUsername: calcStorage.get('steamUsername') || '',
      transactionId: '',
      paymentLink: '',
      paymentType: 'sbp' as User['pay_method'],
      saveLogin: calcStorage.get('saveLogin') ?? true,
      rates: {
        commission: 0,
      },
      selectedCurrency: 'RUB_RUB'
    }),
  
    actions: {
      async checkPromocode(promocode: string) {
        try {
          const response = await fetch(BASE_URL + "/api/check_promocode", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              body: promocode
            })
          });
      
      
          const data = await response.json();
          console.log(data)
          if (data.status === "success") {
            this.discount = data.discount_percent
            this.promocode = promocode;
      
          } else {
            this.promocode = '';
            this.discount = 0;
          }
        } catch (error) {
            this.promocode = '';
            this.discount = 0;
            console.error("Ошибка при проверке промокода. Попробуйте позже.", error);
        }
      },
      async checkUsername() {
        try {
          const response = await fetch(BASE_URL + "/api/steam/check", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              steamUsername: this.steamUsername,
              payment_type: this.paymentType
            })
          });
          const data = await response.json();
      
          if (data.status === "success") {
            // this.steamUsername = username;
            this.transactionId = data.transactionId;
          } else {
            // this.steamUsername = '';
            this.transactionId = '';
          }
        } catch (error) {
          // this.steamUsername = '';
          this.transactionId = '';
          console.log(error)
          console.error("Не удалось создать транзакцию. Пожалуйста, попробуйте позже.");
        }
      },
      async createPaymentLink({amount, steamUsername, transactionId, promocode, telegramId, paymentType}) {
        try {
          const response = await fetch(BASE_URL + "/api/create_payment_link", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              amount,
              description: "Пополнение Steam Bot",
              steamUsername,
              transactionId,
              promocode,
              telegramId,
              payment_type: paymentType
            })
          });
      
          if (!response.ok) {
            throw new Error("Не удалось создать транзакцию. Пожалуйста, попробуйте позже.");
          }
      
          const data = await response.json();
      
          if (data && data.payUrl) {
            this.paymentLink = data.payUrl;
          } else {
            this.paymentLink = '';
          }
        } catch (error) {
          this.paymentLink = '';
          console.log(error)
          console.error("Не удалось создать транзакцию. Пожалуйста, попробуйте позже.");
        }
      },
      async getRates() {
        try {
          const response = await fetch(BASE_URL + "/api/get_rates");
      
          if (!response.ok) {
            throw new Error("Ошибка при получении данных с API");
          }
      
          const data = await response.json();
      
          if (data) {
            this.rates = data;
          }
        } catch (error) {
          console.error("Ошибка при запросе комиссии:", error);
        }
      },
      setCurrency(currency: string) {
        this.selectedCurrency = currency;
      },
    },
    getters: {
      balanceWithCommission: (state) => {
        const currencyPriceAmmount =  state.balance * parseFloat(state.rates[state.selectedCurrency]);
        const commissionAmount = currencyPriceAmmount / 100 * (state.rates.commission - state.discount);
        return currencyPriceAmmount + commissionAmount;
      }
    }
  });